module.exports = __webpack_public_path__ + "img/favicon.d49f753c.jpeg";